module.exports = __webpack_public_path__ + "img/capsules.695cac36.svg";